module.exports = __webpack_public_path__ + "0723b5b881979f3f166b7595137fd7e2.pdf";